import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { clampRadiusKm } from "../search/supplierFilters";
import { getStorageItem } from "../../utils/common-utils";

const readNumber = (params, key) => {
  const raw = params.get(key);
  if (raw === null || raw === "") return null;

  const parsed = Number(raw);

  return Number.isFinite(parsed) ? parsed : null;
};

const useDetailOrigin = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const latitude = readNumber(searchParams, "lat");
  const longitude = readNumber(searchParams, "lng");
  const radiusParam = readNumber(searchParams, "radius");
  const volume = readNumber(searchParams, "volume");
  const containerOptionId = readNumber(searchParams, "option");
  const distanceParam = readNumber(searchParams, "distance");

  const coordinates = useMemo(() => {
    if (latitude !== null && longitude !== null) return { latitude, longitude };

    const stored = getStorageItem("marker-location");

    if (
      stored &&
      Number.isFinite(stored.latitude) &&
      Number.isFinite(stored.longitude)
    ) {
      return { latitude: stored.latitude, longitude: stored.longitude };
    }

    return null;
  }, [latitude, longitude]);

  return {
    coordinates,
    radiusKm: clampRadiusKm(radiusParam),
    hasRadiusParam: radiusParam !== null,
    volume,
    containerOptionId,
    distanceKm: distanceParam,
    searchParams,
    setSearchParams,
  };
};

export default useDetailOrigin;
